var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pool-asset-icon",class:_vm.sizeClass,style:(_vm.wrapStyle)},[(_vm.effectiveLogoUrl)?_c('img',{staticClass:"pool-asset-icon-img",attrs:{"src":_vm.effectiveLogoUrl,"alt":""},on:{"error":_vm.onLogoError}}):_c('span',{staticClass:"pool-asset-icon-letter"},[_vm._v(_vm._s(_vm.iconLetter))])])
}
var staticRenderFns = []

export { render, staticRenderFns }